import { isTrialLicense } from '@monorepo/shared/src/graph/selectors/license-selector';
import useUserStore from '@monorepo/shared/src/graph/hooks/use-user';
// eslint-disable-next-line
import { getNavigationItems } from '@monorepo/shared/src/components/router/NavigationItems';
/**
 *
 * @returns Array of routes to omit @see {@link getNavigationItems}
 */
const useTrialUserOmitRoutes = () => {
  const [{ me }] = useUserStore();
  const license = me?.licenses?.[0];
  const omitReportsForTrialLicense = isTrialLicense(license)
    ? ['/reports', '/assignments', '/assignments/edit/:letter', '/assignments/:letter']
    : [];
  return omitReportsForTrialLicense;
};

export default useTrialUserOmitRoutes;
